import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { createLogger } from './utils/logger';
import './styles/index.css';

const log = createLogger('Global');

// Track unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  log.error('unhandled_rejection', {
    message: event.reason?.message || String(event.reason),
    stack: event.reason?.stack,
  });
});

// Track uncaught errors
window.addEventListener('error', (event) => {
  log.error('uncaught_error', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
